var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.13196 9.16155C2.94578 9.36549 2.96017 9.68174 3.16412 9.86792C3.36806 10.0541 3.68431 10.0397 3.87049 9.83576L9.50122 3.66791L9.50122 17.4987C9.50122 17.7748 9.72508 17.9987 10.0012 17.9987C10.2774 17.9987 10.5012 17.7748 10.5012 17.4987L10.5012 3.6708L16.1293 9.83576C16.3155 10.0397 16.6317 10.0541 16.8357 9.86792C17.0396 9.68174 17.054 9.36549 16.8678 9.16155L10.5538 2.24519C10.426 2.10525 10.2585 2.02542 10.0854 2.00571C10.058 2.00107 10.0299 1.99866 10.0012 1.99866C9.97435 1.99866 9.94797 2.00078 9.92225 2.00486C9.74634 2.02303 9.57568 2.10315 9.446 2.24519L3.13196 9.16155Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.6ff72347f8e9c82fa858c1ae6037127a.svg";
export { ForwardRef as ReactComponent };